export default function getPathWithQueryString(path = '', query = '') {
  if (query) {
    if (query.indexOf('?') === 0) {
      return `${path}${query}`;
    }
    return `${path}?${query}`;
  }
  return path;
}
